import React from 'react';
import { View, Text, StyleSheet, ViewStyle } from 'react-native';
import { Flame } from 'lucide-react-native';
import { useTheme, TYPOGRAPHY } from '../../theme';

interface RediLogoProps {
  fontSize?: number;
  color?: string;
  style?: ViewStyle;
}

export function RediLogo({ fontSize = 22, color, style }: RediLogoProps) {
  const { colors } = useTheme();
  const textColor = color ?? colors.text;
  const flameSize = Math.round(fontSize * 0.4);

  return (
    <View style={[styles.container, style]}>
      <Text style={[styles.text, { fontSize, color: textColor }]}>red</Text>
      <View style={styles.iColumn}>
        <Text style={[styles.text, { fontSize, color: textColor }]}>ı</Text>
        <View style={[styles.flame, { top: -1 }]}>
          <Flame size={flameSize} color={colors.primary} fill={colors.primary} strokeWidth={2} />
        </View>
      </View>
    </View>
  );
}

/**
 * Compact mark for constrained spaces (the map screen's 64px sidebar rail —
 * see SidebarNav). No separate square mark asset exists for the wordmark
 * (assets/icon.png is FirePrep's old orange flame and no longer matches the
 * palette — see the redi-logo-export memory note), so this reuses the exact
 * flame glyph and color token the wordmark already draws next to its dotless
 * "i", just standalone rather than inventing a new logo.
 */
export function RediMark({ size = 24 }: { size?: number }) {
  const { colors } = useTheme();
  return (
    <View style={styles.markContainer}>
      <Flame size={size} color={colors.primary} fill={colors.primary} strokeWidth={2} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'flex-end',
  },
  markContainer: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    fontFamily: TYPOGRAPHY.h1.fontFamily, // already Bold; no fontWeight needed
    letterSpacing: -0.5,
  },
  iColumn: {
    alignItems: 'center',
  },
  flame: {
    position: 'absolute',
    alignSelf: 'center',
  },
});
